import { FaCircleCheck } from "react-icons/fa6";
import { cn, getStatusColor } from "~/lib/utils";

interface Props {
  status: string;
  className?: string;
}
const TableBadge = ({ status, className }: Props) => {
  return (
    <div
      className={cn(
        `${getStatusColor(status)} inline-flex items-center justify-center gap-2 rounded-full px-3 py-1 text-center text-sm`,
        className,
      )}
    >
      {status === "Closed" && <FaCircleCheck className="text-white" />}
      <span>
        {status === "Ready for Review"
          ? "Pending Approval"
          : status === "Closed"
            ? "Approved"
            : status}
      </span>
    </div>
  );
};

export default TableBadge;
